import React from 'react';

const ArrowIcon = ({ width = 80, height = 90 }) => {
    return (
        <svg
            className="arrow-svg"
            width={width}
            height={height}
            viewBox="0 0 88 99"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <filter id="glow-shadow" x="-50%" y="-50%" width="200%" height="200%">
                    <feDropShadow dx="0" dy="0" stdDeviation="6" floodColor="#EF4923" floodOpacity="0.6" />
                </filter>
            </defs>
            <g transform="translate(15, 15)">
                <g className="arrow-shape" stroke="#EF4923" fill="none" fillRule="evenodd">
                    <path
                        d="M29.495.589 57.5 18.276v34.429L29 68.429.5 52.705V18.28L29.495.589z"
                        fill="#15181B"
                    />
                    <path d="m25 44 8-9.412L25 24" />
                </g>
            </g>
        </svg>
    );
};

export default ArrowIcon;
